/**
 * The style position attributes
 * @type {String[]}
 */
const STYLE_POSITION_ATTRIBUTES = [
    'top',
    'left',
    'height',
    'width'
];

module.exports = {
    STYLE_POSITION_ATTRIBUTES
};
